var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHeadingUnderline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 234,
    height: 5,
    viewBox: "0 0 234 5",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M228.635 2.01634C227.979 1.31189 223.453 0.906476 214.458 0.839375C202.357 0.0494907 185.413 -0.0536201 170.775 0.0861751C131.672 0.44154 93.837 0.0682059 55.0812 0.244502C43.9677 0.291373 32.792 0.0478766 20.8872 0.244021C11.3472 0.398377 2.02677 0.801077 0.273694 1.49359C-1.47938 2.1861 6.57488 2.54592 13.8568 2.77744C34.054 3.31701 54.46 3.66464 74.9799 3.81869C114.624 4.24324 155.283 4.27968 196.018 4.27484C200.047 4.25644 204.069 4.27864 208.063 4.34129C216.103 4.51179 224.697 4.58254 230.221 3.86252C234.787 3.22563 236.219 2.52251 228.635 2.01634Z",
    fill: "#FFA13E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeadingUnderline);
export default __webpack_public_path__ + "static/media/heading_underline.12064ae23a78f1651490540f4f9a5716.svg";
export { ForwardRef as ReactComponent };